import { ValidationObserver } from 'vee-validate';

export function formatValidationErrors(
  errors: InstanceType<typeof ValidationObserver>['errors']
) {
  return Object.keys(errors).reduce<string[]>(
    (accumulator, k) => accumulator.concat(errors[k]),
    []
  );
}
